import React, { Fragment } from 'react';
import classNames from 'classnames';
import { Comment, ErrorMessage, hoc, Radio } from 'src/core';
import { getTextFromCheckboxQuestionValue } from '../../utils';
import {
  CheckboxRadioListItemWrapper,
  CheckboxRadioListWrapper
} from '../shared';
import { useRadioQuestionProps } from './radio-question.props';
import styles from './radio-question.module.scss';

/**
 * <RadioQuestion />
 */
const RadioQuestion = hoc(
  useRadioQuestionProps,
  ({
    question,
    configuredList,
    value,
    isBigList,
    isError,
    error,
    onChange
  }) => (
    <Fragment>
      <CheckboxRadioListWrapper>
        {configuredList.map(({ text, label, imageUrl, comment }, index) => {
          const checked = text === getTextFromCheckboxQuestionValue(value);

          return (
            <>
              {!!label ? (
                <p className={styles.title}>{label}</p>
              ) : (
                <CheckboxRadioListItemWrapper
                  key={index}
                  onCheckboxRadioClick={() =>
                    onChange(
                      question,
                      comment ? { answer: text, comment: '' } : text
                    )
                  }
                  isImageUrl={configuredList.some(({ imageUrl }) => imageUrl)}
                  commentVal={comment}
                  comment={
                    <React.Fragment>
                      {comment && (
                        <Comment
                          name={text}
                          disabled={!checked}
                          value={typeof value === 'string' ? '' : value.comment}
                          onChange={event => {
                            const commentValue =
                              typeof value === 'string'
                                ? { answer: text }
                                : value;
                            return onChange(question, {
                              ...commentValue,
                              comment: event.target.value
                            });
                          }}
                        />
                      )}
                    </React.Fragment>
                  }
                >
                  <Radio
                    classes={{
                      root: classNames(isBigList && styles.radio__small_root),
                      flag: classNames(isBigList && styles.radio__small_flag),
                      label: classNames(isBigList && styles.radio__small_font)
                    }}
                    question={question}
                    label={text}
                    image={imageUrl}
                    value={checked}
                    disabled={checked}
                    onChange={() => {}}
                    isError={isError}
                    error={error}
                  />
                </CheckboxRadioListItemWrapper>
              )}
            </>
          );
        })}
      </CheckboxRadioListWrapper>

      <ErrorMessage error={error} isError={isError} />
    </Fragment>
  )
);

export { RadioQuestion };
